import { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { publicRoutes, privateRoutes } from "Router/Routes";
import Loader from "Components/Shared/Loader";
import { Box, Container } from "@mui/material";
import WrapHeader from "Components/Shared/wrapHeader";
import WrapContainer from "Components/Shared/wrapContainer";
import BodyWrapper from "./BodyWrapper";

import { useUserContext } from "Hooks/UserContext";

import { ASSOCIATE_BUYER_SLUG } from "Static/utils/commonUtils";

/**
 * Body of loggedIn User
 * @returns Body of the application
 */
const UserBody = () => {
  const { userDetails } = useUserContext();
  const CurrentUserRole = userDetails
    ? userDetails.role_slug === ASSOCIATE_BUYER_SLUG
      ? userDetails.role_slug
      : "User"
    : "";

  // Function will check and redirect if user do not have permission of selected module

  return (
    <Box px={{ sm: 3, xs: 0 }} py={2}>
      <Container maxWidth={false} className="App">
        <Suspense fallback={<Loader />}>
          <Routes>
            {privateRoutes[CurrentUserRole] &&
              privateRoutes[CurrentUserRole].map(({ path, ComponentIn, header = false }, key) => {
                return (
                  <Route
                    key={key}
                    path={path}
                    caseSensitive
                    match="exact"
                    element={
                      <BodyWrapper>
                        <ComponentIn />
                      </BodyWrapper>
                    }
                  />
                );
              })}

            {publicRoutes.map(({ path, ComponentIn, header = false }, key) => {
              return (
                <Route
                  key={key}
                  path={path}
                  element={
                    header ? (
                      <WrapHeader>
                        <WrapContainer maxWidth={header}>
                          <ComponentIn />
                        </WrapContainer>
                      </WrapHeader>
                    ) : (
                      <WrapContainer maxWidth={header}>
                        <ComponentIn />
                      </WrapContainer>
                    )
                  }
                />
              );
            })}
          </Routes>
        </Suspense>
      </Container>
    </Box>
  );
};

export default UserBody;
